module.exports = __webpack_public_path__ + "static/img/4.fa0510a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/eng/4.png
// module id = 11xl
// module chunks = 0